<div
    *ngIf="value"
    class="agpr-chips ui-chips ui-widget"
    [ngClass]="styleClass"
    [class.agpr-chips--hasChips]="value && value.length > 0"
>
    <agpr-dropdown #theDropdown
        [id]="id + '.dropdown'"
        class="ui-inputwrapper-focus"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [options]="options"
        [tooltipPath]="tooltip"
        [agprStyle]="style"
        [keepSelectedValue]="false"
        (change)="addSelectedChip($event.value)"
        [itemTooltipPosition]="itemTooltipPosition"
        [ariaDescribedBy]="(id + '_chips') + ' ' + (id + '_errors') + ariaDescribedBy"
        [ariaLabelledBy]="ariaLabelledBy"
        (blur)="blur.emit($event)"
    ></agpr-dropdown>
    <ul
        #chipList
        [id]="id + '_chips'"
        *ngIf="valueWithLabels.length > 0"
        class="agpr-chips-list"
    >
        <li
            #token
            *ngFor="let chip of valueWithLabels; index as i"
            class="agpr-chip"
            [id]="id + '.chip_' + i"
            [attr.aria-label]="chip[labelLookupValue]"
        >
            <span
                class="agpr-chip-label"
                [pTooltip]="style === agprComponentStyle.social ? chip[labelLookupValue] : ''"
                tooltipPosition="top"
            >
                {{ chip[labelLookupValue] }}
            </span>
            <button
                [id]="id + '.chip_' + i + '.delete'"
                class="agpr-chip-icon agpr-i-close"
                agprTooltip="Common.forms.chips.delete"
                tooltipPosition="top"
                [useTooltipAsAriaLabel]="false"
                (click)="removeChip($event, chip)"
                [attr.aria-label]="chip[labelLookupValue] + ' ' + ('Common.forms.chips.delete' | localize)"
            ></button>
        </li>
    </ul>
</div>
<ul [id]="id + '_errors'">
    <li *ngIf="showError">
        <agpr-form-message>
            {{ errorMessage }}
        </agpr-form-message>
    </li>
    <li *ngFor="let error of chipValidationErrors">
        <agpr-form-message>
            {{ error.detail }}
        </agpr-form-message>
    </li>
</ul>
